"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetsStyling = void 0;
var react_1 = __importDefault(require("react"));
var tiny_invariant_1 = __importDefault(require("tiny-invariant"));
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var WidgetAdderUtils_1 = require("Project/QwilrEditor/Widgets/WidgetAdder/WidgetAdderUtils");
var ExpandableSection_1 = require("./ExpandableSection");
var EditorWidgetRegistry_1 = require("Project/QwilrEditor/WidgetRegistry/EditorWidgetRegistry");
var GetTraitConfig_1 = require("@CommonFrontend/WidgetRegistry/Utils/GetTraitConfig");
var widgetStyle_1 = require("@CommonFrontend/Utils/widgetStyle");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var PropertyControls_1 = require("Project/QwilrEditor/RegistryElement/PropertyControls/PropertyControls");
var ROICalculatorControls_1 = require("./ROICalculatorControls");
exports.WidgetsStyling = (0, mobx_react_1.observer)(function () {
    var e_1, _a;
    var _b;
    var usingFeature = (0, inversify_react_1.useInjection)("usingFeature");
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var stylePermissionStore = (0, inversify_react_1.useInjection)("stylePermissionStore");
    var blockStyleStore = blockStore.blockStyleStore;
    var widgetAdderList = (0, WidgetAdderUtils_1.getWidgetAdderOptions)({
        filterText: "+",
        inLayoutType: null,
        tokensAvailable: false,
        usingFeature: usingFeature,
    });
    var styleableWidgets = [];
    try {
        for (var widgetAdderList_1 = __values(widgetAdderList), widgetAdderList_1_1 = widgetAdderList_1.next(); !widgetAdderList_1_1.done; widgetAdderList_1_1 = widgetAdderList_1.next()) {
            var _c = widgetAdderList_1_1.value, type = _c.type, icon = _c.icon, displayName = _c.displayName;
            var widgetConfig = (0, EditorWidgetRegistry_1.getGenericConfigByType)(type);
            (0, tiny_invariant_1.default)(!!widgetConfig, "Could not find widget with type: ".concat(type));
            var styleableConfig = (0, GetTraitConfig_1.getTraitConfig)({ widgetType: widgetConfig.type, traitName: "styleable" });
            if (!styleableConfig) {
                continue;
            }
            var styleKey = styleableConfig.styleKey, properties = styleableConfig.properties, styleAccessKey = styleableConfig.styleAccessKey;
            if (!!styleAccessKey && !stylePermissionStore.allowStyle(styleAccessKey)) {
                continue;
            }
            var blockStyle = (_b = blockStyleStore.getElementStyle(styleKey)) !== null && _b !== void 0 ? _b : {};
            var style = (0, widgetStyle_1.widgetStyle)({
                blockStyle: blockStyle,
                colorProvider: colorProvider,
                overrides: {},
                styleableConfig: { styleKey: styleKey, properties: properties },
                paragraphBlockStyle: blockStyleStore.getElementStyle("p"),
                heading2BlockStyle: blockStyleStore.getElementStyle("h2"),
            });
            styleableWidgets.push({ type: type, icon: icon, displayName: displayName, styleableConfig: styleableConfig, style: style });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (widgetAdderList_1_1 && !widgetAdderList_1_1.done && (_a = widgetAdderList_1.return)) _a.call(widgetAdderList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return (react_1.default.createElement(kaleidoscope_1.Stack, null, styleableWidgets.map(function (_a) {
        var type = _a.type, icon = _a.icon, displayName = _a.displayName, style = _a.style, styleableConfig = _a.styleableConfig;
        return (react_1.default.createElement(ExpandableSection_1.ExpandableSection, { key: type, icon: icon, displayName: displayName },
            react_1.default.createElement(kaleidoscope_1.Stack, { gap: "m", padding: "s" },
                react_1.default.createElement(StyleableControls, { styleKey: styleableConfig.styleKey, properties: styleableConfig.properties, style: style }))));
    })));
});
var StyleableControls = (0, mobx_react_1.observer)(function (_a) {
    var _b;
    var styleKey = _a.styleKey, properties = _a.properties, style = _a.style;
    var blockStore = (0, inversify_react_1.useInjection)("blockStore");
    var blockStyleStore = blockStore.blockStyleStore;
    var blockStyle = (_b = blockStyleStore.getElementStyle(styleKey)) !== null && _b !== void 0 ? _b : {};
    var onChangeHandler = function (property, value) {
        var nextStyle = (0, lodash_1.cloneDeep)(blockStyle);
        (0, lodash_1.set)(nextStyle, property.path, value);
        blockStyleStore.setElementStyle(styleKey, nextStyle);
    };
    if (styleKey === "roiCalculator") {
        return react_1.default.createElement(ROICalculatorControls_1.ROICalculatorControls, { properties: properties, style: style, onChangeHandler: onChangeHandler });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, properties.map(function (p) {
        return (react_1.default.createElement(PropertyControls_1.PropertyControls, { key: p.path, onChangeHandler: onChangeHandler, property: p, style: style, target: "blockStyle" }));
    })));
});
